import React from "react";
import Banner from "../Utils/GenericUI/Banner.jsx";
import { header, Body } from "../Utils/StaticData/UserCreationStaticData";
import history from "../Utils/History";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import { signUp, guestLogin } from "../Redux/Actions/webAppActions";
import Footer1 from "../Utils/GenericUI/Footer1";
import { INITIAL_STATE } from "./initialState";
import { Text } from "react-internationalization";
class UserCreation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      pswd: "",

      conf_pd: "",
      showPassword: false,
      passwordEye: false,
      showConfirmPassword: false,
      confirmPasswordEye: false,
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      modified: false,
    };
    this.validator = new SimpleReactValidator();
  }
  componentDidMount() {
    window.scroll(0, 0);
  }

  handleChange = async (event) => {
    const { pswd } = this.state;
    const name = event.target.name;
    const value = event.target.value;
    const emailError =
      name === "email" &&
      (!this.validator.check(value, "email") || value === "");
    const passwordError = name === "password" && value === "";
    const confirmPasswordError =
      name === "conf_pd" && (value === "" || pswd !== value);

    await this.setState({
      [name]: value,
      emailError: emailError,
      passwordError: passwordError,
      confirmPasswordError: confirmPasswordError,
      modified: true,
    });
  };

  handleFocus = (name) => (event) => {
    event.preventDefault();
    const showPasswordEye = name === "password";
    const showConfirmPasswordEye = name === "conf_pd";
    this.setState({
      passwordEye: showPasswordEye,
      confirmPasswordEye: showConfirmPasswordEye,
    });
  };

  handleOnBlur = (name) => (event) => {
    event.preventDefault();
    const {
      showConfirmPassword,
      showPassword,
      email,
      pswd,
      conf_pd,
    } = this.state;
    const showPasswordEye = name === "password" && showPassword;
    const showConfirmPasswordEye =
      name === "conf_pd" && showConfirmPassword;
    const emailError =
      name === "email" &&
      (!this.validator.check(email, "email") || email === "");
    const passwordError = pswd === "";
    const confirmPasswordError =
      conf_pd === "" || pswd !== conf_pd;
    this.setState({
      passwordEye: showPasswordEye,
      confirmPasswordEye: showConfirmPasswordEye,
      emailError: emailError,
      passwordError: passwordError,
      confirmPasswordError: confirmPasswordError,
    });
  };

  showPassword = (name, toggle) => (event) => {
    document.getElementById(name).focus();
    const eyeIcon = name === "password" ? "passwordEye" : "confirmPasswordEye";
    const show = name === "password" ? "showPassword" : "showConfirmPassword";
    this.setState({
      [eyeIcon]: true,
      [show]: toggle,
    });
  };

  signUp = async (e) => {
    // e.preventDefault();
    const { email, pswd, conf_pd } = this.state;

    const emailError = !this.validator.check(email, "email") || email === "";

    const confirmPasswordError =
      conf_pd === "" || pswd !== conf_pd;

    if (emailError) {
      let msg=this.props.lang==="es"?"El formato de correo electrónico es incorrecto":"Email format is incorrect"
      alert(msg);
      return;
    }
    if (!pswd) {
      let msg=this.props.lang==="es"?"Por favor, ingrese contraseña":"Please enter Password"
      alert(msg);
      return;
    }
    if (confirmPasswordError) {
      let msg=this.props.lang==="es"?"Las contraseñas no coinciden. Vuelva a ingresar":"Passwords do not match - Please Re-enter"
      alert(msg);
      return;
    }
    let body = {
      emailAddress: email,
      password: pswd,
      reconfirmPwd: conf_pd,
    };
    body = { ...body, customerId: "HCF0331" };
    const signup = await this.props.signUp(body);
    if (signup.message === "SUCCESS")
      history.push("/webapp/Sharp/Individual/yearSelection");
    else alert(signup.message);
  };
  continueAsGuest = async (e) => {
    e.preventDefault();
    const guestLogin1 = await this.props.guestLogin(INITIAL_STATE.customerId);
    if (guestLogin1.data === "Logged in as guest")
      history.push("/webapp/Sharp/Individual/yearSelectionGuest");
    else {
      let msg=this.props.lang==="es"?"Error de inicio de sesion":"Login Failed"
      alert(msg);
    }
  };
  login = (e) => {
    e.preventDefault();
    history.push("/webapp/Sharp/Individual/userLogin");
  };
  render() {
    const {
      pswd,
      conf_pd,
      email,
      showPassword,
      showConfirmPassword,
      passwordEye,
      confirmPasswordEye,
      emailError,
      passwordError,
      confirmPasswordError,
    } = this.state;
    return (
      <div id="userCreation">
        <Banner header={header} Body={Body} />
        <div class="container mt-3">
          <div class="tab-content">
            <div class="container form-panel">
              <div class="form-group row">
                <div class="col-md-12">
                  <label for="emailAddress" class="control-label">
                    <Text id="user.emailAdd"/>*
                  </label>

                  <input
                    type="email"
                    name="email"
                    placeholder="john.smith@mail.com"
                    class={emailError ? "error-input" : "form-control"}
                    value={email}
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur("email")}
                  />
                  <br />
                  <label for="password" class="control-label">
                    <Text id="user.pd_user"/>*
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="pswd"
                    class={passwordError ? "error-input" : "form-control"}
                    value={pswd}
                    onFocus={this.handleFocus("password")}
                    onBlur={this.handleOnBlur("password")}
                    onChange={this.handleChange}
                  />
                  {passwordEye ? (
                    <div 
                      class="eyeIcon-password"
                      onMouseUp={this.showPassword("password", false)}
                      onMouseDown={this.showPassword("password", true)}
                      onMouseOut={this.showPassword("password", false)}
                    >
                      <RemoveRedEyeIcon />
                    </div>
                  ) : null}
                  <br />
                  <label for="reenterpwd" class="control-label">
                    <Text id="user.re_ent_pd"/>*
                  </label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="conf_pd"
                    class={
                      confirmPasswordError ? "error-input" : "form-control"
                    }
                    autoFocus
                    name="conf_pd"
                    value={conf_pd}
                    onFocus={this.handleFocus("conf_pd")}
                    onBlur={this.handleOnBlur("conf_pd")}
                    onChange={this.handleChange}
                  />
                  {confirmPasswordEye ? (
                    <div
                      class="eyeIcon-confirm-password"
                      onMouseUp={this.showPassword("conf_pd", false)}
                      onMouseDown={this.showPassword("conf_pd", true)}
                      onMouseOut={this.showPassword("conf_pd", false)}
                    >
                      <RemoveRedEyeIcon onClick={this.showPassword} />
                    </div>
                  ) : null}
                </div>
              </div>
              <div class="button-container-login-page" style={{marginTop: "30px"}}>
                <button
                  class="btn btn-login margin-right1"
                  id="continue-as-a-guest"
                  onClick={this.continueAsGuest}
                >
                  <Text id="user.guest"/>
                </button>
                <button
                  class="btn btn-login"
                  id="signup"
                  onClick={this.signUp}
                  disabled={!this.state.modified}
                >
                  <Text id="user.sign"/>
                </button>
                <div class="already-have-account">
                  <p>
                   <Text id="user.already"/> <br />
                    <a href="#none" onClick={this.login}>
                      <Text id="user.log"/>
                    </a>
                  </p>
                </div>
              </div>
           </div>
          </div>
        </div>
        <Footer1 />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang:state.webApp.language,
  };
};
const mapDispatchToProps = {
  signUp,
  guestLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCreation);
